import React, { useCallback } from "react";
import { useRecoilState } from "recoil";
import Toast from "./index";
import { toastStateAtom } from "./toastState";

const ToastContainer: React.FC = () => {
  const [toastState, setToastState] = useRecoilState(toastStateAtom);

  const handleCloseToast = useCallback(() => {
    // Defer so the library's onClose call (which may fire during render)
    // doesn't trigger a setState on this component while a sibling is
    // still rendering — avoids React's "setState in render" warning.
    queueMicrotask(() => setToastState(undefined));
  }, [setToastState]);

  return toastState ? (
    <Toast
      open={toastState.open}
      message={toastState.message}
      severity={toastState.severity}
      onClose={handleCloseToast}
    />
  ) : null;
};

export default ToastContainer;
